// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"b9870f1a","160":"b9870f1a","232":"b9870f1a","243":"b7402897","373":"bef8435e","448":"b9870f1a","482":"b9870f1a","515":"2bf09f6e","671":"b9870f1a","817":"b9870f1a","837":"2bf09f6e","972":"b9870f1a"}[chunkId] + ".chunk.css";
};